import PropTypes from 'prop-types';
import React from 'react';
import { kebabCase } from 'lodash';
import dateFormatConstant from '../../../constants/dateFormatConstant';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import DateTimePicker from '../../common/controls/dateTimePicker';
import Label from './label';
import logValueOnChange from '../commonActions/logValueOnChange';
import localChangeSelector from '../selectors/localChangeSelector';
import customerConfigurationSelector from '../selectors/customerDateFormatSelector';
const DatePickerField = ({
  enabled,
  label: _label = null,
  testingIdentifier: _testingIdentifier = 'default-id',
  value: _value = null,
  onChange,
  path,
  localChangeFunc,
  customerDateFormat: _customerDateFormat = 'month-first'
}) => {
  const dateFormat = dateFormatConstant[_customerDateFormat];
  const handleChange = async updateValue => {
    if (updateValue !== _value) {
      const d = new Date(updateValue);
      const log = {
        path,
        value: updateValue,
        displayValue: d.toDateString()
      };
      await onChange(localChangeFunc(log));
    }
  };

  /**
   * Handle when picker opens with no value - set default to today's date at current time in UTC
   * (i.e., uses now.toISOString(), which returns the current date and time in UTC)
   */
  const handleOpen = () => {
    if (_value === null || _value === undefined) {
      // Get current time and represent it as a UTC ISO string
      const now = new Date();
      const currentDateTime = now.toISOString();
      handleChange(currentDateTime);
    }
  };
  const id = `dpf-${kebabCase(_label)}`;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": id
  }, /*#__PURE__*/React.createElement(Label, {
    value: _label
  }), /*#__PURE__*/React.createElement(DateTimePicker, {
    disabled: !enabled,
    onChange: handleChange,
    value: _value,
    onOpen: handleOpen,
    className: `${kebabCase(_testingIdentifier)} tqc-date-picker-field`,
    verticalPadding: false,
    dateFormat: dateFormat
  }));
};
DatePickerField.propTypes = {
  enabled: PropTypes.bool.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  testingIdentifier: PropTypes.string,
  value: PropTypes.string,
  path: PropTypes.string.isRequired,
  localChangeFunc: PropTypes.func.isRequired,
  customerDateFormat: PropTypes.string
};
export { DatePickerField as UncomposedDatePickerField };
export default entityComposition(DatePickerField, [], {
  customerDateFormat: customerConfigurationSelector,
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector,
  localChangeFunc: localChangeSelector
});